var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"placebadge",class:{'gold': _vm.primary, 'white': !_vm.primary, 'small': _vm.isSmall()}},[_vm._v(" Locul "),_c('b',[_vm._v(_vm._s(_vm.place))])])}
var staticRenderFns = []

export { render, staticRenderFns }